/**
 * MCE adapters carry their one-hot exclusion in `Archive.Adapter.
 * one_hot_exclusion_binary` rather than inside `cdo_input`, which no MCE save
 * sends. Requires LiftCloud LC-13, which reads the field on Create and Update
 * and returns it on adapter responses. Other protocols keep the cdo_input path.
 */
import * as flatbuffers from "flatbuffers";
import { bytesToBase64 } from "../../utils/base64";
import {
  OneHotExclusionConfig,
  OneHotExclusionConfigT,
} from "../generated/one-hot-exclusion/one-hot-exclusion-config";

/** Base64 of the packed config. A zero-group config clears the stored one. */
export function oneHotExclusionToBase64(config: OneHotExclusionConfigT): string {
  const builder = new flatbuffers.Builder(256);
  builder.finish(config.pack(builder));
  return bytesToBase64(builder.asUint8Array());
}

/** The config in an adapter response's binary field, or undefined when absent or unreadable. */
export function decodeOneHotExclusion(
  bytes: ArrayLike<number> | null | undefined,
): OneHotExclusionConfigT | undefined {
  if (!bytes || bytes.length === 0) return undefined;
  try {
    const buf = new flatbuffers.ByteBuffer(Uint8Array.from(bytes));
    return OneHotExclusionConfig.getRootAsOneHotExclusionConfig(buf).unpack();
  } catch {
    return undefined;
  }
}
